import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../reducers';
import { ProjectLanguage, Question } from '@nexxt/common/types';
import { saveOptionPack } from '../../../../../../../services/optionpack.service';
import NotifyHOC from '../../../../../../../HOC/Notifications';

interface SaveOptionLibraryPopoverProps {
    languages: ProjectLanguage[];
    question: Question;
    toastNotification;
    onClose: () => void;
    saveOptionPack: (data) => Promise<boolean>;
}

const SaveOptionLibraryPopover: React.FC<SaveOptionLibraryPopoverProps> = ({
    languages,
    question,
    toastNotification,
    onClose,
    saveOptionPack
}: SaveOptionLibraryPopoverProps) => {
    const [label, setLabel] = React.useState(question.title);

    const handleSaveOptionpack = async (e) => {
        if (!label?.length) {
            return;
        }
        e.stopPropagation();
        try {
            const resp = await saveOptionPack({
                languages,
                availableOptions: question.options?.map((opt) => ({
                    ...opt,
                    conditions: [] // reset conditions before saving a new optionpack
                })),
                label,
                tags: [],
                optionType: question.selectedOptionType,
                optionSettings: {
                    notApplicableTexts: question?.notApplicableTexts || [],
                    showNotApplicableOption:
                        question?.showNotApplicableOption || false,
                    showOther: question?.optionSettings?.showOther || false,
                    showSpecify: question?.optionSettings?.showSpecify || false,
                    otherOption: question?.optionSettings?.otherOption || {}
                }
            });
            if (resp) {
                toastNotification.success(
                    'Successfully added to option library'
                );
            }
        } catch (err) {}

        onClose();
    };
    return (
        <div className="popover--container">
            <div className="popover--container--header">
                <div className="popover--container--header--title">
                    <input
                        className="question--title"
                        value={label}
                        onChange={(e) => {
                            e.stopPropagation();
                            setLabel(e.target.value);
                        }}
                        placeholder="Edit label here"
                    />{' '}
                    {/* Options Saved to Library */}
                </div>
                <button
                    type="button"
                    className="popover--container--header--close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onClose}
                >
                    <span aria-hidden="true">
                        <i className="nx nx-close"></i>
                    </span>
                </button>
            </div>
            <div className="popover--container--body">
                <div className="option--library">
                    <div>
                        Review <b>{question.options.length}</b> options to be
                        saved to Option Library:
                    </div>
                    <div>
                        {question.options.map((opt) => (
                            <span className="option--label" key={opt.value}>
                                # {opt.label}
                            </span>
                        ))}
                        {question.showNotApplicableOption && (
                            <span className="option--label">
                                # Not Applicable
                            </span>
                        )}
                        {question?.optionSettings?.showOther && (
                            <span className="option--label"># Other</span>
                        )}
                    </div>
                    <div>
                        In <b>{languages?.length} languages:</b>{' '}
                        {languages.map((language) => language.label).join(', ')}
                    </div>
                </div>
            </div>
            <div className="popover--container--footer">
                {/* <button className="btn btn--sm btn--lt-gray mr-2 disabled">
                    Edit in Option Library
                </button> */}
                <button
                    className="btn btn--sm btn--blue"
                    onClick={handleSaveOptionpack}
                >
                    Save to Library
                </button>
            </div>
        </div>
    );
};

const mapStateToProps = ({}: IApplicationState) => ({});

const mapDispatchToProps = (dispatch) => ({
    saveOptionPack: (data) => dispatch(saveOptionPack(data))
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(SaveOptionLibraryPopover)
);
